// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2YAaW","content":"styles__content___3IeRX","logoWrapper":"styles__logoWrapper___1cK4U"};